import * as request from './request';
import $ from "jquery";
import * as language from './lang';
import configLang from './configLang';
import { getParam } from 'utilsES';

import '../img/yysj_favicon.png';
import '../img/antslg_favicon.png';
import '../img/ztmslg_favicon.png';
import '../img/ztmslgtw_favicon.png';
import '../img/ztmslgkr_favicon.png';
import '../img/ztmslgme_favicon.png';
import '../img/dtmslg_favicon.png';
import '../img/dtmslgtw_favicon.png';
import '../img/dtmslgjk_favicon.png';
import '../img/beast_favicon.png';
import '../img/zljslg_favicon.png';
import '../img/xdgslg_favicon.png';
import '../img/zroute_favicon.png';

$(async function () {
  let lang = getBrowserLang();
  let submitForm = {
    serverName: '',
    sid: '',
    id: '',
    roleName: '',
    giftCode: '',
    roleId: '',
  }
  const gameName = {
    191: "ztmslg",
    217: "yysj",
    263: "antslg",
    288: "antslg",
    285: "dtmslg",
    354: "dtmslg",
    355: "dtmslg",
    295: "beast",
    331: "zljslg",
    440: "xdgslg",
    466: "xdgslg",
    454: "zroute",
  }
  let gameId = request.gameId;
  let isLogin = false;
  const needLoginGameId = [295, 440];
  const isNeedLoginGame = needLoginGameId.includes(+gameId);
  // 初始化
  initGamePage(lang);
  initLang(lang);
  await initServer();
  autoSetForm();
  initUserInfo();
  initEvent();
  dataLayer.push({
    event: 'entrance',
    scid: getParam('scid'),
    cid: getParam('cid')
  });

  function getBrowserLang() {
    // 特殊处理，蚂蚁军团_越南版固定越南语
    if(getParam('gameId') == 288) return 'vi';
    
    let appLanguage = getParam('appLanguage');
    let language = getParam('language');
    let lang = appLanguage || language || window.navigator.language || window.navigator.browserLanguage || window.navigator.systemLanguage;
    lang = lang.toLowerCase();
    lang = !lang ? 'en' : lang; // 如果是undefined的话就用默认英语
    return lang;
  }

  function getLang(lang) {
    let realLang = '';
    let keyArr = [...Object.keys(language.lang)];
    for (let i = 0; i < keyArr.length; i++) {
      if (keyArr[i].includes(lang)) {
        realLang = keyArr[i];
        break;
      }
    }
    realLang = realLang === '' ? 'en-us' : realLang;
    return realLang;
  }

  function setLang(lang, type = 'lang') {
    let realLang = '';
    if (lang.includes("ar")) {
      realLang = 'ar-sa';
    } else {
      let keyArr = [...Object.keys(language.lang)];
      for (let i = 0; i < keyArr.length; i++) {
        if (keyArr[i].includes(lang)) {
          realLang = keyArr[i];
          break;
        }
      }
    }
    realLang = realLang === '' ? 'en-us' : realLang;
    return language[type][realLang] ? language[type][realLang] : language[type]['en-us'];
  }

  function showTip(text, islongText = false, confirmText) {
    islongText ? $('.j-popup-tip-content').addClass('popup-content-long') : $('.j-popup-tip-content').removeClass('popup-content-long');
    $('.j-popup-tip-content').text(text);
    $('.j-popup-tip-confirm').text(confirmText ? confirmText : 'OK')
    $('.j-popup-tip').fadeIn();
  }

  function visibleValidPopup(visible) {
    const $ele = $('.j-popup-valid');
    visible ? $ele.fadeIn() : $ele.fadeOut();
  }

  function login() {
    let forwardUrl = '';
    const matchHost = window.location.host.match(/\.?([A-za-z0-9]*\.com)/);
    const HOST = matchHost ? matchHost[1] : '37games.com';
    forwardUrl = `//gevents.${HOST}/gamecode/index.html?gameId=${gameId}&sicd=${getParam('scid')}&cid=${getParam('cid')}` +
      `&autoServerName=${submitForm.serverName}` +
      `&autoServerID=${submitForm.id}` +
      `&autoServerSID=${submitForm.sid}` +
      `&autoRoleName=${encodeURIComponent(submitForm.roleName)}` +
      `&autoGiftCode=${submitForm.giftCode}`;

    const LOGIN_URL = `//gabres.${HOST}/platform/login.html?gameId=${gameId}&device=${window.platform.isPhone() ? 2 : 1
      }&forward=${encodeURIComponent(forwardUrl)}`;
    window.location.href = LOGIN_URL;
  }

  function setSubmitForm({ serverName, sid, id, roleName, giftCode }) {
    submitForm.serverName = serverName || '';
    submitForm.sid = sid || '';
    submitForm.id = id || '';
    submitForm.roleName = roleName || '';
    submitForm.giftCode = giftCode || '';
  }

  function setInputDom({ sid, roleName, giftCode }) {
    setServerDom(!sid, sid);
    chooseRole(roleName);
    $('.character-value').val(roleName || '');
    $('.code-value').val(giftCode || '');
  }

  function autoSetForm() {
    let autoServerName = getParam('autoServerName');
    let autoServerID = getParam('autoServerID');
    let autoServerSID = getParam('autoServerSID');
    let autoRoleName = getParam('autoRoleName');
    let autoGiftCode = getParam('autoGiftCode');
    try {
      autoRoleName = decodeURIComponent(autoRoleName);
      const autoForm = {
        serverName: autoServerName,
        sid: autoServerSID,
        id: autoServerID,
        roleName: autoRoleName,
        giftCode: autoGiftCode
      }
      setSubmitForm(autoForm);
      setInputDom(autoForm);
    } catch (e) {
      const emptyForm = {
        serverName: '',
        sid: '',
        id: '',
        roleName: '',
        giftCode: ''
      }
      setSubmitForm(emptyForm);
      setInputDom(emptyForm);
      console.error(e);
    }
  }

  function setServerDom(boolPlaceholder, sid) {
    const $ele = $('#server');
    boolPlaceholder ? $ele.addClass('grey') : $ele.removeClass('grey');
    sid && $ele.val(sid);
  }

  function setRoleStyle(boolPlaceholder) {
    const $ele = $('#role');
    boolPlaceholder ? $ele.addClass('grey') : $ele.removeClass('grey');
  }

  async function chooseRole(roleName) {
    const roleList = await getRoleList();
    if(!roleName) return;
    const roleItem = roleList.find((item) => item.roleName == roleName);
    if(roleItem) {
      $('#role').val(roleItem.roleID);
      submitForm.roleId = roleItem.roleID;
      submitForm.roleName = roleItem.roleName;
      setRoleStyle(false);
    } else {
      submitForm.roleName = '';
      submitForm.roleId = '';
      setRoleStyle(true);
    }
  }

  function setRoleValue(boolPlaceholder = false) {
    const $ele = $('#role');
    boolPlaceholder ? $ele.addClass('grey') : $ele.removeClass('grey');
  } 

  function initGamePage(lang) {
    // 设置页签
    let faviconURL = '';
    if (gameName[gameId] === "ztmslg") {
      switch (getLang(lang)) {
        case 'zh-tw':
          faviconURL = './img/ztmslgtw_favicon.png';
          break;
        case 'ko-kr':
          faviconURL = './img/ztmslgkr_favicon.png';
          break;
        case 'ar-sa':
          faviconURL = './img/ztmslgme_favicon.png';
          break;
        default:
          faviconURL = './img/ztmslg_favicon.png';
      }
    } else if (gameName[gameId] === "dtmslg") {
      switch (getLang(lang)) {
        case 'zh-tw':
          faviconURL = './img/dtmslgtw_favicon.png';
          break;
        case 'ko-kr':
          faviconURL = './img/dtmslgjk_favicon.png';
          break;
        case 'ja-jp':
          faviconURL = './img/dtmslgjk_favicon.png';
          break;
        default:
          faviconURL = './img/dtmslg_favicon.png';
      }
    } else {
      faviconURL = './img/' + gameName[gameId] + '_favicon.png';
    }
    $('.j-favicon').attr('href', faviconURL);
    if (gameName[gameId] === "antslg") {
      $('body').removeClass("ztmslg yysj antslg dtmslg beast zljslg xdgslg zroute").addClass("antslg");
    } else if (gameName[gameId] === "yysj") {
      $('body').removeClass("ztmslg yysj antslg dtmslg beast zljslg xdgslg zroute").addClass("yysj");
    } else if (gameName[gameId] === "dtmslg") {
      $('body').removeClass("ztmslg yysj antslg dtmslg beast zljslg xdgslg zroute").addClass("dtmslg");
    } else if (gameName[gameId] === "beast") {
      $('body').removeClass("ztmslg yysj antslg dtmslg beast zljslg xdgslg zroute").addClass("beast");
    } else if (gameName[gameId] === "zljslg") {
      $('body').removeClass("ztmslg yysj antslg dtmslg beast zljslg xdgslg zroute").addClass("zljslg");
    } else if (gameName[gameId] === "xdgslg") {
      $('body').removeClass("ztmslg yysj antslg dtmslg beast zljslg xdgslg zroute").addClass("xdgslg");
    } else if (gameName[gameId] === "zroute") {
      $('body').removeClass("ztmslg yysj antslg dtmslg beast zljslg xdgslg zroute").addClass("zroute");
    } else {
      $('body').removeClass("ztmslg yysj antslg dtmslg beast zljslg xdgslg zroute").addClass("ztmslg");
    }
  }

  function initLang(lang) {
    // 设置logo
    $('.logo').addClass("logo-" + gameName[gameId]);
    if (lang.includes("ar")) {
      $('body').addClass("ar");
      $(".j-step-title-icon").addClass("ar-icon");
      $('.logo').addClass("logo-ar");
    } else {
      $('.logo').addClass(setLang(lang, 'logo'));
    }

    // 设置页面元素语言
    for (let i = 0; i < configLang.length; i++) {
      $(configLang[i].el).text(setLang(lang)[configLang[i].langKey]);
    }
    $('.step-cont2-tip').text(setLang(lang)[isNeedLoginGame ? 'needLoginGameStep2' : 'step2']);
    setServerDom(true);
    setRoleValue(true);
    $('.character-value').attr('placeholder', setLang(lang).pleaseInputRole);
    $('.code-value').attr('placeholder', setLang(lang).insertGift);
  }

  function initServer() {
    const emptyServer = `<option value="" data-id="" data-servername="">${setLang(lang).pleaseSelectServer}</option>`;
    return request.get('listServer')
      .then(({ data }) => {
        let tpl = emptyServer;
        for (let i = 0, length = data.length; i < length; i++) {
          tpl += `<option value="${data[i].sid}" data-id="${data[i].id}" data-servername="${data[i].sname}">${data[i].sname}</option>`
        }
        $('#server').html(tpl);
      })
      .catch((err) => {
        $('#server').html(emptyServer);
      });
  }

  function initRole(boolLogin) {
    if(boolLogin) {
      $('.character-value').hide();
      $('.j-form-select-role').show();
    } else {
      $('.j-form-select-role').hide();
      $('.character-value').show();
    }
  }

  function getRoleList(autoSelectFirst) {
    const emptyRole = `<option value="" data-rolename="">${setLang(lang).pleaseInputRole}</option>`;
    return new Promise((resolve) => {
      request.getRole({
        server_id: submitForm.sid
      }).then(({data}) => {
        setRoleStyle(true);
        if(!/Array/i.test(data.constructor.toString())) {
          $('#role').html(emptyRole);
          return;
        }
        let tpl = emptyRole;
        for(let i = 0, length = data.length; i < length; i++) {
          tpl += `<option value="${data[i].roleID}" data-rolename="${data[i].roleName}">${data[i].roleName}</option>`
        }
        $('#role').html(tpl);
        if(autoSelectFirst && data.length > 0 && data[0]) {
          $('#role').val(data[0].roleID);
          submitForm.roleId = data[0].roleID;
          submitForm.roleName = data[0].roleName;
          setRoleStyle(false);
        }
        resolve(data);
      }).catch((err) => {
        if(err.code == '-10000') {
          showTip(setLang(lang).frequently);
        }
        setRoleStyle(true);
        $('#role').html(emptyRole);
        resolve([]);
      })
    }) 
  }

  async function initUserInfo() {
    await request.getUserInfo()
      .then((res) => {
        isLogin = true;
        $('.j-account-name').text(res.data.DISPLAY_NAME || res.data.LOGIN_ACCOUNT);
        $('.j-account').show();
        $('.j-title').removeClass('more-padding');
      })
      .catch((e) => {
        if (isNeedLoginGame) {
          login();
        }
        isLogin = false;
        $('.j-account-name').text('');
        $('.j-account').hide();
        $('.j-title').addClass('more-padding');
      })
      .finally(() => {
        initRole(isLogin);
      })
  }

  function initEvent() {
    let requesting = false;

    $('#server').on('change', () => {
      const targetOption = $('#server option:selected');
      const sid = targetOption.val();
      const id = targetOption.attr('data-id');
      const serverName = targetOption.attr('data-servername');
      if (id && sid && serverName) {
        setServerDom(false);
        submitForm.id = id;
        submitForm.sid = sid;
        submitForm.serverName = serverName;
        submitForm.roleId = '';
        submitForm.roleName = '';
        isLogin && getRoleList(true);
      } else {
        submitForm.id = '';
        submitForm.sid = '';
        submitForm.serverName = '';
        submitForm.roleId = '';
        submitForm.roleName = '';
        $('#role').val('');
        setRoleStyle(true);
        setServerDom(true);
      }
    })
    $('#role').on('change', () => {
      if(!isLogin) return;
      const targetOption = $('#role option:selected');
      const roleId = targetOption.val();
      const roleName = targetOption.attr('data-rolename');
      if(roleId && roleName) {
        setRoleStyle(false);
        submitForm.roleId = roleId;
        submitForm.roleName = roleName;
      } else {
        setRoleStyle(true);
        submitForm.roleId = '';
        submitForm.roleName = '';
      }
    })
    // 提示弹窗
    $('.j-popup-tip-shadow').on('click', () => {
      $('.j-popup-tip').fadeOut();
    })
    $('.j-popup-tip-close').on('click', () => {
      $('.j-popup-tip').fadeOut();
    })
    $('.j-popup-tip-confirm').on('click', () => {
      $('.j-popup-tip').fadeOut();
    })
    // 去校验弹窗
    $('.j-popup-valid-shadow').on('click', () => {
      $('.j-popup-valid').fadeOut();
    })
    $('.j-popup-valid-close').on('click', () => {
      $('.j-popup-valid').fadeOut();
    })
    $('.j-popup-valid-confirm').on('click', () => {
      login();
      $('.j-popup-valid').fadeOut();
    })
    $('.character-value').on('input', (e) => {
      submitForm.roleName = e.target.value;
    })
    $('.code-value').on('input', (e) => {
      submitForm.giftCode = e.target.value;
    })
    // 切换账号
    $('.j-account-change').on('click', async() => {
      const logoutRes = await request.getLogout();
      +logoutRes.result == 1 ? login() : showTip('Error');
    })
    // 兑换
    $('.j-form-submit').on('click', async() => {
      if (requesting) {
        return;
      }
      if(!isLogin) {
        submitForm.roleName = $('.character-value').val();
      }
      submitForm.giftCode = $('.code-value').val();
      if (submitForm.sid == '' || submitForm.id == '') {
        showTip(setLang(lang).pleaseSelectServer);
        return;
      }
      if (submitForm.roleName == '') {
        showTip(setLang(lang).pleaseInputRole);
        return;
      }
      if (submitForm.giftCode == '') {
        showTip(setLang(lang).insertGift);
        return;
      }
      requesting = true;
      request.get('commonAwardNew', {
        game_id: gameId,
        server_id: submitForm.id,
        server_id2: submitForm.sid,
        gift_code: submitForm.giftCode,
        role_name: encodeURIComponent(encodeURIComponent(submitForm.roleName)),
        role_id: submitForm.roleId,
        language: getLang(lang).slice(0, 3) + getLang(lang).slice(3).toUpperCase()
      }, true).then(() => {
        showTip(setLang(lang).done);
        dataLayer.push({ 'event': 'rewardSuccess' });
      }).catch(({ code, msg }) => {
      
        switch (code) {
          case -20001:
            showTip(setLang(lang).characterNotFound);
            break;
          case -20002:
            showTip(setLang(lang).fail);
            break;
          case -20003:
            showTip(setLang(lang).invalidCode);
            break;
          case -20004: 
            visibleValidPopup(true);
            break;
          case -20005:
          case -20006:
          case -20007:
            showTip(setLang(lang)[code]);
            break;
          default:
            showTip(msg);
        }
        dataLayer.push({
          'event': 'rewardFail',
          'reason': msg
        });
      }).finally(() => {
        requesting = false;
      })
    })
  }
})


